export const orderType = [
    {id: "ingreso", value: "Ingreso"},
    {id: "retiro", value: "Retiro"},
    {id: "periódico", value: "Periódico"},
    {id: "pos_incapacidad", value: "Pos incapacidad"},
    {id: "reubicación_laboral", value: "Reubicación laboral"},
];

export const headers = {
    initialHeaders: [
        { title: "Fecha de creación", field: "creationDate", child: null },
        { title: "Nombre del empleado", field: "fullName", child: null },
        { title: "Regional", field: "regionalName", child: null },
        { title: "Cargo", field: "charge", child: null,},
        {title: "Tipo de orden", field: "orderType", child: null,},
        {title: "Correo Electrónico", field: "userEmail", child: null,}
      ],
};

export const initialStateForm = {
    firstName: "",
    secondName: "",
    surname: "",
    secondSurname: "",
    regionalId: "",
    documentType: "",
    document: "",
    examType: "",
    observationExam: "",
    email: "",
    medicalExam: "",
    observation: "",
    retiro: "",
};